import React, { FC } from "react";

import { Tabs } from "@components/common";
import { useRecommendationsStore } from "@store/recommendations";

type Tab = "co2" | "archive";

interface Component {}

const Component: FC<Component> = () => {
  const { activeTab, setActiveTab, setFilter } = useRecommendationsStore();

  const handleChange = (event: React.SyntheticEvent, value: Tab): void => {
    setActiveTab(value);
    setFilter({
      scopes: [],
      types: [],
      states: [],
    });
  };

  return (
    <Tabs<Tab>
      tabs={[
        {
          title: "CO2",
          path: "co2",
        },
        {
          title: "Archive",
          path: "archive",
        },
      ]}
      activeTab={(activeTab as Tab) || "co2"}
      onChange={handleChange}
    />
  );
};

export default Component;
